import { render, staticRenderFns } from "./StaticsTable.vue?vue&type=template&id=6b35b3a4&"
import script from "./StaticsTable.vue?vue&type=script&lang=js&"
export * from "./StaticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports